import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import * as actions from './store/actions'
import * as types from './store/types'
import vuetify from './plugins/vuetify';
import Amplify from 'aws-amplify'
import {onAuthUIStateChange} from '@aws-amplify/ui-components'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')


const poolData = {
  userPoolId: process.env?.VUE_APP_AUTH_POOL_ID ?? "POOL_ID_NOT_LOADED_FROM_ENV",
  userPoolWebClientId: process.env?.VUE_APP_AUTH_CLIENT_ID ?? "AUTH_CLIENT_ID_NOT_LOADED_FROM_ENV"
}

Amplify.configure({
  Auth: {
    region: 'us-east-1',
    ...poolData
  }
})

onAuthUIStateChange((authState, authData: any) => {
  if(authState === 'signedin') {
    // console.log({authData})
    const user: types.Schema$User = {
      username: authData.attributes?.email ?? "NULL_USERNAME",
      emailVerified: authData.attributes?.email_verified ?? "NULL_EMAIL_VERIFIED",
      phoneNumber: authData.attributes?.phoneNumber ?? "NULL_PHONE_NUMBER",
      sub: authData.attributes?.sub ?? "NULL_SUB",
      name: authData.attributes?.name ?? "NULL_NAME",
      idToken: authData.signInUserSession?.idToken.jwtToken ?? "NULL_TOKEN"
    }
    store.commit(actions.UPDATE_USER, user)
    store.dispatch(actions.CREATE_WEBSOCKETS_CONNECTION)
      .then(() => void store.dispatch(actions.FETCH_LAYERS)) 
  } else {
    store.commit(actions.LOG_OUT) 
  }
})